import { useLazyQuery } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { gql } from '@/__generated__';
import { AiFilterTestInput } from '@/__generated__/graphql';

const TEST_AI_FILTER = gql(`
  query TestAIFilter($filter: AIFilterTestInput!, $text: String!) {
    aiFilterTest(filter: $filter, text: $text)
  }
`);

export const useTestAiFilter = (filter: AiFilterTestInput, text?: string) => {
  const toast = useToast();
  const [testFilter, { data, loading, error }] = useLazyQuery(TEST_AI_FILTER, {
    onError: (error) => {
      toast.error({
        title: 'Error testing AI filter',
        subTitle: error?.message || 'Please try again',
      });
    },
  });

  const runTest = () => {
    testFilter({
      variables: {
        filter,
        text: text || '',
      },
    });
  };

  return {
    testFilter: runTest,
    result: data?.aiFilterTest,
    loading,
    error,
  };
};
